// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"69a5e8d8","455":"7ce8742c","488":"42ea1fd6"}[chunkId] + ".chunk.js";
};